import React from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { TABLE_ROW } from '../itemIds';

interface Props {
  value: string;
  children?: [];
}

export type TableRowDefinition = ItemDefinition<typeof TABLE_ROW>;

export class TableRow extends Item<typeof TABLE_ROW, Props> {
  protected render({ id, children }: RenderProps<Props>) {
    const tdList = children ? children[0] : [];

    return (
      <tr key={`tr_${id}`}>
        {tdList.map((node: React.ReactNode, index: number) => {
          if (id == 'table_header') {
            return <th key={`td_${id}_${index}`}>{node}</th>;
          }
          return <td key={`td_${id}_${index}`}>{node}</td>;
        })}
      </tr>
    );
  }
}

registry[TABLE_ROW] = TableRow;
